module.exports = "/images/es-variant.svg?3ffa730240777fd64ede2650a1d6f28a";